import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  static generatedPdfKey: string = 'QuickFiles application';

  documentUrlDictionary: { key: string, url: string[] }[] = [];
  constructor() { }

  getUrls(): any {
    return this.documentUrlDictionary;
  }

  getUploadedFilesString(): any {
    var fileString = "";
    this.documentUrlDictionary.forEach(function (item) {
      if (item.key != AppService.generatedPdfKey) {
        item.url.forEach(element => {
          var urlTemp = element.toString().split("/");
          console.log(urlTemp);
          fileString += urlTemp[urlTemp.length - 1] + ";   ";
        });
      }
    });
    if (fileString.length > 0) {
      return fileString.substr(0, fileString.length - 1);
    }
    return fileString;

  }
  setUrl(key: string, uploadingUrls: string[]) {
    let noSpaceUrls = uploadingUrls.flatMap(u => {
      return u.replace(' ', '');
    });
    let uniqueDecodedUploadingUrls = noSpaceUrls.filter((v, i, a) => a.indexOf(v) === i).map(u => decodeURI(u));
    let existingUrlsWithSameKey = this.documentUrlDictionary.filter(item => item.key == key).flatMap(item => item.url);
    let newUrls: string[] = [];
    uniqueDecodedUploadingUrls.forEach(u => {
      // New url doesn't exist in current url list.
      if (existingUrlsWithSameKey.indexOf(u) < 0) {
        newUrls.push(u);
      }
    })

    if (newUrls.length > 0) {
      // Only push new urls
      var pair = { key: key, url: newUrls };
      this.documentUrlDictionary.push(pair);
    }
  }
}
